import React, { useEffect, useState } from "react";
import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faCircleExclamation, faCircleCheck, faCircleInfo, faComment } from '@fortawesome/free-solid-svg-icons';
import { useHttpUtils } from './Utilities/useHttpUtils';

export type Variant = "danger" | "success" | "warning" | "info" | "primary" | "secondary";

export default function AlertBanner() {
    const [dismissSiteAlert, setDismissSiteAlert] = useState(false);
    const [siteAlert, setSiteAlert] = useState("");
    const [siteAlertVariant, setSiteAlertVariant] = useState<Variant>();
    const { fetchDataAuthenticated } = useHttpUtils();

    useEffect(() => {
        getSiteAlert();
        let delay: number = 1000 * 60 * 0.5;
        const interval = setInterval(() => {
            getSiteAlert();
        }, delay)

        return () => clearInterval(interval);
    }, [])

    function getVariantIcon(variant?: Variant) {
        switch (variant) {
            case "danger":
                return faCircleExclamation;
            case "warning":
                return faTriangleExclamation;
            case "success":
                return faCircleCheck;
            case "info":
                return faCircleInfo;
            default:
                return faComment;
        }
    }

    function getSiteAlert() {
        let url: string = "api/v1/users/siteAlert";
        fetchDataAuthenticated(url)
            .then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        setSiteAlert(data.text);
                        setSiteAlertVariant(data.variant);
                    })
                }
            })
            .catch(error => console.error(error.message));
    }

    return (
        <Alert variant={siteAlertVariant} className={"fs-5"} show={!dismissSiteAlert && !!siteAlert} onClose={() => setDismissSiteAlert(true)}  dismissible>
            <FontAwesomeIcon
                icon={getVariantIcon(siteAlertVariant)}
                className="me-3"
            />
                {siteAlert}
        </Alert>
    )
}
